import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useEffect, useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useCalculateSettlement = (agreementId) => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "calculateSettlement"
  );
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    setComplete(false);
  }, [agreementId]);
  const calculateSettlement = async () => {
    try {
      const result = await executeCallable({ agreementId });
      setComplete(true);
      return result;
    } catch (err) {
      setComplete(false);
    }
  };
  return {
    saving,
    error,
    success: !saving && !error && complete,
    calculateSettlement,
  };
};
